export default __webpack_public_path__ + "static/media/cory_2.68b4ded6.png";